import FpModal from './FpModal.jsx'
import FpModalHeader from './FpModalHeader.jsx'
import FpModalBody from './FpModalBody.jsx'
import FpModalFooter from './FpModalFooter.jsx'

FpModal.Header = FpModalHeader
FpModal.Body = FpModalBody
FpModal.Footer = FpModalFooter

export { FpModal, FpModalHeader, FpModalBody, FpModalFooter }
export default FpModal
